<template>
  <div>
    <div class="columns toolbar-box action-right">
      <div class="column is-3">
        <h1 class="title is-3 between-center">
                    <span>
                        <span>Billing Summary</span>
                    </span>
        </h1>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <autocomplete-select
              v-model="filters.companyId"
              type="company"
              field-name="name"
              placeholder="Search by Company"
              @update:modelValue="fetchReportData()"
          />
        </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <o-select :expanded="true" placeholder="Select Year" v-model="filters.year" @update:modelValue="fetchReportData()">
            <option value="">Select Year</option>
            <option :value="year" v-for="year in years" v-bind:key="year">
              {{ year }}
            </option>
          </o-select>
        </o-field>
      </div>
    </div>

    <o-table
        table-class="report-table"
        :data="rows"
        :loading="loading"
        :total="total"
        :per-page="perPage"
        paginated
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        backend-sorting
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
        @page-change="onPageChange"
        @sort="onSort">
      <template>
        <template>
          <o-table-column
              #default="{row}"
              v-for="(col, idx) in columns" :key="idx + '_' + col.field"
              :field="col.field"
              :label="col.label"
              :sortable="col.sortable">
            <span v-if="col.money">{{ $filters.currency(row[col.field]) }}</span>
            <span v-else-if="col.field === 'percentage'" >
              {{ row[col.field] }}%
            </span>
            <span v-else>{{ row[col.field] }}</span>
          </o-table-column>
        </template>
      </template>
    </o-table>

    <div>Total: <strong>{{ total }}</strong></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from '../../mixins/Table'
import Datepicker from '../../components/Datepicker'

export default {
  mixins: [Table],

  components: {
    Datepicker
  },

  created () {
    this.filters = {
      companyId: '',
      year: (new Date).getFullYear()
    }
  },

  data () {
    return {
      contactItem: null,
      currentCompany: null,
      isComponentModalActive: false,
      rows: [],
      total: 0,
      loading: false,
      sortField: "name",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      page: 1,
      perPage: 20,
      columns: [],
    }
  },

  methods: {
    fetchReportData()  {
      this.loading = true;
      let params = {year: this.filters.year, company: this.filters.companyId}
      axios.get('/api/reports/billing_summary', { params })
          .then(res => {
            this.rows = res.data.data.summary;
            this.total = res.data.data.summary.length;
            this.columns = res.data.data.columns;
            this.loading = false;
          })
    },

    onPageChange(p) {
      this.page = p;
      this.fetchReportData();
    },

    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
    },
  },

  computed: {
    ...mapGetters(['years']),

    ...mapGetters({
      itemsByIds: 'companiesByIds'
    }),

  },

  beforeMount() {
    this.fetchReportData()
  },
}
</script>
